import syntaxHighlight from '~/syntax_highlight';
import highlightCurrentUser from './highlight_current_user';
import { renderKroki } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_kroki.js?vue3';
import renderMath from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_math.js?vue3';
import renderSandboxedMermaid from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_sandboxed_mermaid.js?vue3';
import renderIframe from './render_iframe';
import { renderGlql } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_glql.js?vue3';
import { renderJSONTable, renderJSONTableHTML } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_json_table.js?vue3';
import { addAriaLabels } from './accessibility';
import { renderImageLightbox } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_image_lightbox.js?vue3';
import renderMarkdownTables from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/render_markdown_tables.js?vue3';
import markPrintScaleTables from './mark_print_scale_tables';
import initPopovers from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/markdown/init_popovers.js?vue3';
import { GFM_POPOVER_SELECTOR, GFM_LIGHTBOX_IMAGE_SELECTOR } from './constants';

// Render GitLab Flavored Markdown.
//
// This function handles components originating from backend-rendered GLFM that need
// frontend work to vivify them.  It is purpose built to co-operate with the Banzai
// pipeline system in `lib/banzai`, and will not work correctly with HTML generated
// using other methods (e.g. Marked).  Modifying it to also work with other sources
// may compromise the security of GitLab, as it affects how we handle the output from
// the backend.
export function renderGFM(element) {
  if (!element) {
    return;
  }

  function arrayFromAll(selector) {
    return Array.from(element.querySelectorAll(selector));
  }

  const highlightEls = arrayFromAll('.js-syntax-highlight');
  const krokiEls = arrayFromAll('.js-render-kroki[hidden]');
  const mathEls = arrayFromAll('.js-render-math');
  const mermaidEls = arrayFromAll('.js-render-mermaid, code.language-mermaid');
  const iframeEls = arrayFromAll('.js-render-iframe');
  const tableEls = arrayFromAll('[data-canonical-lang="json"][data-lang-params~="table"]');
  const tableHTMLEls = arrayFromAll('table[data-table-fields]');
  const mdTableEls = arrayFromAll('.md table:not(.code)');
  const glqlEls = arrayFromAll('[data-canonical-lang="glql"], .language-glql');
  const userEls = arrayFromAll('.gfm-project_member');
  const popoverEls = arrayFromAll(GFM_POPOVER_SELECTOR);
  const taskListCheckboxEls = arrayFromAll('.task-list-item-checkbox');
  const imageEls = arrayFromAll(GFM_LIGHTBOX_IMAGE_SELECTOR);

  syntaxHighlight(highlightEls);
  renderKroki(krokiEls);
  renderMath(mathEls);
  renderSandboxedMermaid(mermaidEls);
  renderIframe(iframeEls);
  renderJSONTable(tableEls.map((e) => e.parentNode));
  renderJSONTableHTML(tableHTMLEls);
  renderMarkdownTables(mdTableEls);
  markPrintScaleTables(mdTableEls);
  highlightCurrentUser(userEls);
  initPopovers(popoverEls);
  addAriaLabels(taskListCheckboxEls);
  renderGlql(glqlEls);
  renderImageLightbox(imageEls, element);
}
